import momentget from 'moment-timezone';
function getTimeZoneAndOffset() {
    const timeZone = momentget.tz.guess(); 
    const offset = momentget().tz(timeZone).format('Z');
    
    // console.log(`Timezone: ${timeZone}/UTC${offset}`);
 
    return ` ${timeZone}(UTC${offset})`;
}
export default getTimeZoneAndOffset